import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Select, { components } from 'react-select';

import { useCatalogHierarchy } from '../../hooks/useCatalogHierarchy';
import { transformBrandsToOptions } from '../Products/form/lib/brandHelpers';

import './CreationRequestBrandSelect.scss';

// The menu renders every option it is handed, so a search shows its first matches only.
const MAX_OPTIONS_SHOWN = 100;

/**
 * A search over every catalog brand, by name or domain.
 * @param {{ value: number, label: string }|null} value
 */
const CreationRequestBrandSelect = ({ value, onChange, autoFocus }) => {
  const { brands } = useCatalogHierarchy();
  const options = useMemo(() => transformBrandsToOptions(brands), [brands]);
  return (
    <Select
      className='creation-request-brand-select'
      classNamePrefix='crbs'
      options={options}
      value={value}
      onChange={onChange}
      isLoading={!brands}
      menuPlacement='auto'
      placeholder='Search catalog brands'
      aria-label='Catalog brand'
      autoFocus={autoFocus}
      components={{ MenuList: FirstMatchesMenuList }}
    />
  );
};

const FirstMatchesMenuList = props => (
  <components.MenuList {...props}>
    {props.selectProps.inputValue ? React.Children.toArray(props.children).slice(0, MAX_OPTIONS_SHOWN) : <div className='crbs-hint'>Type a brand name or domain</div>}
  </components.MenuList>
);

CreationRequestBrandSelect.propTypes = {
  value: PropTypes.shape({ value: PropTypes.number, label: PropTypes.string }),
  onChange: PropTypes.func.isRequired,
  autoFocus: PropTypes.bool
};

export default CreationRequestBrandSelect;
